<h1 class="page-title mb-5"> عن الادارة المركزية للمسئولية المجتمعية </h1>
<div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9">
                <div class="content-wrapper">
                    <p class="mb-4 description-text">
                        تهدف الهيئة العامة للاستثمار والمناطق الحرة إلى تشجيع المسئولية المجتمعية للشركات وسلوك الأعمال
                        المسئول من خلال نشر الوعي وتبادل أفضل الممارسات ودعم تنسيق أفضل لأنشطة المسئولية المجتمعية
                        للشركات.
                    </p>
                    <p class="mb-4 description-text">
                        وفي ضوء الحرص على تكامل جهود القطاع الخاص مع الدولة في مجال التنمية من خلال أنشطة المسئولية
                        المجتمعية للشركات لتحقيق التنمية المستدامة، استحدثت الهيئة العامة للاستثمار والمناطق الحرة في
                        عام 2019 " <span class="fw-bold">إدارة المسئولية المجتمعية</span>" لتكون مهمتها ما يلي:
                    </p>

                    <ul class="custom-list mb-4">
                        <li>تشجيع وتنمية مبادرات المسئولية المجتمعية داخلياً (الهيئة) وخارجياً (الشركات) وفقاً
                            لاستراتيجيه الهيئة والمعايير المحليه والدوليه في مجال التنمية المستدامة.</li>
                    </ul>

                    <h4 class="fw-bold mb-3 section-title">يتم تحقيق ذلك من خلال العمل على:</h4>
                    <ul class="custom-list mb-5">
                        <li>نشر الوعي بمفاهيم المسئولية المجتمعية وتكافؤ الفرص لتحقيق التنمية المستدامة.</li>
                        <li>تشجيع الشركات على تبني وتطبيق ممارسات المسئولية المجتمعية/الاستدامة.</li>
                        <li>تقييم ومتابعه أثر أنشطه المسئولية المجتمعية/الاستدامة للشركات التي يتم إجراؤها.</li>
                        <li>إصدار قائمة بأفضل الشركات الرائدة في مجال المسئولية المجتمعية.</li>
                    </ul>

                    <div class="download-links mb-5">
                        <div class="mb-2">
                            <a href="#" class="text-decoration-none purple-link fw-bold">المستندات المطلوبة للتقديم
                                للمسابقة</a>
                        </div>
                        <div class="mb-2">
                            <a href="#" class="text-decoration-none purple-link fw-bold">معايير التقييم</a>
                        </div>
                        <div class="mb-2">
                            <a href="#" class="text-decoration-none purple-link fw-bold">الحوافز المقترحة للشركات
                                الرائدة</a>
                        </div>
                    </div>

                    <div class="more-info mb-4">
                        <p class="d-inline">لمزيد من المعلومات حول مهام وجهود قسم المسئولية المجتمعية للشركات</p>
                        <a href="../../assets/CSR GAFI- Sep. 2025.pdf"
                            class="text-danger fw-bold ms-1 text-decoration-underline">اضغط هنا</a>
                    </div>

                    <div class="contact-info mt-4 pt-3 border-top">
                        <h5 class="fw-bold d-inline-block ms-2">للتواصل مع الإدارة والاستفسارات:</h5>
                        <a href="mailto:csr&#64;gafinet.org.eg"
                            class="fw-bold text-dark dir-ltr">csr&#64;gafinet.org.eg</a>
                    </div>
                </div>
            </div>

            <div class="col-md-3">
                <app-fix-how-we-can-help></app-fix-how-we-can-help>
            </div>
        </div>
    </div>
</div>